import React, { Component } from 'react';
import './styles.css';
const URLSearchParams = require('url-search-params');

class Thanks extends Component {
	componentDidMount() {
		const urlParams = new URLSearchParams(window.location.search);
		window._adftrack = Array.isArray(window._adftrack) ? window._adftrack : (window._adftrack ? [window._adftrack] : []);
		window._adftrack.push({
			pm: 307530,
			divider: encodeURIComponent('|'),
			pagename: encodeURIComponent('TYP_SEGUGIO_LEAD'),
			order: {
				orderid: urlParams.get('j')
			}
		});
		(function () {
			var s = document.createElement('script');
			s.type = 'text/javascript';
			s.async = true;
			s.src = 'https://track.adform.net/serving/scripts/trackpoint/async/';
			var x = document.getElementsByTagName('script')[0];
			x.parentNode.insertBefore(s, x);
		})();
	}

	render() {
		return (
			<div>
				<div className="thanks" {...this.props}>
					<div className="thanks-cont">
						<h3> Grazie! </h3>
						<div
							style={{
								height: '2vh'
							}}
						/>
						<p className="thanks-paragraph">
							{`
							Verrai ricontattato al più presto da un consulente TIM nelle seguenti fasce orarie:
							`}
						</p>
						<p className="thanks-paragraph">
							{`
							Il servizio è gratuito ed è attivo
							`}
							<br />
							{
								`
								lun-ven dalle 9 alle 21 e sab-dom dalle 9 alle 18
								`
							}
						</p>
					</div>
				</div>
			</div >
		);
	}
}

export default Thanks;



// WEBPACK FOOTER //
// ./src/screens/Thanks/index.js